export default __webpack_public_path__ + "static/media/light-top-desktop.6d55e603.webp";